import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const saveProjectTask =  {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        isProjectTaskSave: false,
        isShowProjectTaskModal: false
    },
    mutations: {
        UPDATE_VISIBLE_MODAL_PROJECT_TASK(state, value) {
            state.isProjectTaskSave = value;
        },
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            let dataReceive = {
                title: response.data.message,
                message: response.data.data.textInfo,
                projectId: response.data.data.projectId,
                projectTask: response.data.data.projectTask
            };
            eventBus.$emit("saveProjectTaskSuccess", dataReceive);
        },
        DATA_SAVE_FAILURE(state, error) {
            state.isProjectTaskSave = true;
            eventBus.$emit("saveProjectTaskFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_PROJECT_TASK_MODAL(state, value) {
            state.isShowProjectTaskModal = value;
        }
    },
    actions: {
        storeProjectTask: function({ dispatch }, payload) {
            dispatch("requestDataSave", true);
            let url = new URL(window.location.href);

            if (!payload.creds.projectId) {
                payload.creds.data.projectId = url.searchParams.get("id");
            } else {
                payload.creds.data.projectId = payload.creds.projectId
            }
            if(payload.creds.data.executionDate !== undefined || payload.creds.data.executionTime !== undefined) {
                payload.creds.data.executionDay = payload.creds.data.executionDate;
            }
            if(payload.creds.data.executionDate === null) {
                delete payload.creds.data.executionDay;
            }

            let promise = sendRequest("post", config.baseURLApi + "/project-tasks", {}, payload.creds.data);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1]);
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                dispatch("requestDataSave", false);
            });
        },
        requestDataSave: function({ commit }, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataSave: function({ commit }, response) {
            commit("DATA_SAVE_SUCCESS", response);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModalProjectTask: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_PROJECT_TASK", value);
        },
        updateVisibleProjectTaskModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_PROJECT_TASK_MODAL", value);
        }
    }
}

export default saveProjectTask;